<template>
<div class="bind" name="bind">
  <topNav :title="title"></topNav>
  <div class="payContent">
    <div class="bind_card" >

      <div class="bbc">
        <label class="bui-checkbox-label bui-checkbox-anim">
          <p>
           <i class="icon iconfont">&#xe60f;</i>
             <span>建设银行</span>
        </p>
        <input type="radio" name="sex" value="CCB" v-model="myval"><i class="bui-checkbox"></i>
        </label>

      </div>
       <div class="construction">
          <label class="bui-checkbox-label bui-checkbox-anim">
            <p>
             <i class="icon iconfont">&#xe689;</i>
             <span>工商银行</span>
        </p>
        <input type="radio" checked  name="sex" value="ICBC" v-model="myval"><i class="bui-checkbox" ></i>
        </label>

      </div>


    </div>
      <div class="open_info">
         <p>选择银行卡进行无感支付绑定</p>
         <div class="pay_btn" @click="selectCard()">确定</div>
    </div>
  </div>
</div>

</template>
<script>
import topNav from "../topnav/topnav";
export default {
  name: "bind",
  components: {
    topNav,
  },
  data() {
    return {
       myval:"CCB",
       title:"银行卡选择"
    }
  },
  methods:{
    selectCard:function(){
      if(this.myval=="ICBC"){
        //  this.$router.push('/bindcard');
        this.$dialog.alert({
      title: '提示',
      message: '该功能正在开发中，尽情期待！！！'
    })
      }
      else{
        this.$router.push('/CCBprocedure');
      }

    }

  },
};
</script>
<style>
.pay_btn {
  width: 92%;
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  background-color: rgb(70, 135, 248);
  color: white;
  margin: 1.5rem auto;
  border-radius: 5px;
  font-size: 1.1rem;
  -webkit-box-shadow: 0.1rem 0.1rem 0.7rem #a3a3a3;
  box-shadow: 0rem 0.2em 0.8rem #5b82c18a;
}
.open_info{
  margin-top: 9%;
}
.open_info p{
  font-size: 13px;
}
label.bui-checkbox-label input[type="radio"]{
      visibility: hidden;
      opacity: 0;
  }
  label.bui-checkbox-label .bui-checkbox{
      display: inline-block;
      position: relative;
      width: 15px;
      height: 15px;
      border: 1Px solid rgb(70, 135, 248);
      background-color: #fff;
      vertical-align: -2px;
      margin-right: 5px;
      border-radius: 100%;
  }
  label.bui-checkbox-label input[type="radio"]:checked + .bui-checkbox:after{
      position: absolute;
      content: "";
      width:10px;
      height: 4px;
      border-left:2px solid #fff;
      border-bottom: 2px solid #fff;
      transform: rotate(-45deg) translate(-50%,-50%);
      /*top:50%;*/
      left:50%;
  }
  label.bui-checkbox-label input[type="radio"]:checked + .bui-checkbox {
      background-color: rgb(70, 135, 248);
  }
  label.bui-checkbox-label input[type="radio"]:disabled + .bui-checkbox{
      background-color: #e8e8e8;
      border:1Px solid #979797;
  }

  label.bui-checkbox-label.bui-checkbox-anim .bui-checkbox{
      -webkit-transition:background-color ease-in-out .3s;
      transition:background-color ease-in-out .3s;
  }
  @font-face {
  font-family: 'iconfont';  /* project id 891193 */
  src: url('//at.alicdn.com/t/font_891193_fq4wstr1wma.eot');
  src: url('//at.alicdn.com/t/font_891193_fq4wstr1wma.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_891193_fq4wstr1wma.woff') format('woff'),
  url('//at.alicdn.com/t/font_891193_fq4wstr1wma.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_891193_fq4wstr1wma.svg#iconfont') format('svg');
}
.iconfont {
  font-family:"iconfont" !important;
  font-size:18px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

  .construction .iconfont{
    color:rgb(213, 37, 41);
  }
    .bbc .iconfont{
    color:rgb(0, 91, 171);
  }
  .bind_card>div label{
    display: flex;
    width: 90%;
    margin: 0 auto;
    padding: 12px 0;
    position: relative;
    justify-content:space-between;
  }
  .bind_card>div{
   background: white;
  }
  .bind_card .bbc{
    margin: 10px 0;
  }
  .bui-checkbox{
    right: 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/nofeel/nofeel.vue